import { APP_ROUTES } from "@src/constants";
import { useNavigateWithUTM } from "@src/hooks/useNavigateWithUTM";
import { styled } from "@uhg-abyss/web/tools/styled";
import { Button } from "@uhg-abyss/web/ui/Button";
import { Heading } from "@uhg-abyss/web/ui/Heading";
import { IconSymbol } from "@uhg-abyss/web/ui/IconSymbol";
import type { CSSProperties, ReactNode } from "react";

interface SearchAgainUIProps {
  headingText: string | ReactNode;
  subText: string | ReactNode;
  isMobile: boolean;
  css?: CSSProperties; // Allow inline style overrides
  isSearchAgain?: boolean;
  secondaryCta?: {
    label: string;
    onClick: () => void;
    id: string;
    dataObcLabel: string;
  };
}

const SearchAgainContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  gap: "8px",
  maxWidth: "443px",
});

export const SearchAgain = ({
  headingText,
  subText,
  isMobile,
  css,
  isSearchAgain = true,
  secondaryCta,
}: SearchAgainUIProps) => {
  const navigate = useNavigateWithUTM();

  return (
    <SearchAgainContainer className="search-again-holder" style={css}>
      <IconSymbol
        className="search-again-icon"
        icon="search"
        size={54}
        color={"$app.color.icon.primary.interactive"}
      />
      <Heading
        className="search-again-heading"
        css={{
          "abyss-heading-root": {
            fontSize: isMobile ? "18px" : "20.25px",
            lineHeight: "24px",
          },
        }}
      >
        {headingText}
      </Heading>
      <div className="search-again-subtext">{subText}</div>
      {isSearchAgain && (
        <Button
          data-testid="test-id-provider-list-search-again-button"
          id="obc-find-provider-search-again-btn"
          data-obc-label="Find Provider Search Again Button"
          onClick={() => {
            return navigate(APP_ROUTES.GET_STARTED);
          }}
          style={{ marginTop: "8px" }}
        >
          Search Again
        </Button>
      )}
      {secondaryCta && (
        <Button
          data-testid="test-id-provider-list-secondary-cta-button"
          id={secondaryCta.id}
          data-obc-label={secondaryCta.dataObcLabel}
          onClick={secondaryCta.onClick}
          variant="outline"
          style={{ marginTop: isSearchAgain ? "0" : "8px" }}
        >
          {secondaryCta.label}
        </Button>
      )}
    </SearchAgainContainer>
  );
};
